import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'replace', standalone: false })
export class ReplacePipe implements PipeTransform {
  transform( value: string, strToReplace: string, replacementStr: string ): string {
    return value.replace(new RegExp(this.escapeStr(strToReplace), 'g'), replacementStr);
  }

  escapeStr( str ) {
    return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }

}
